import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Printer, Loader2, AlertCircle } from "lucide-react";
import CertificateView from "@/components/CertificateView";
import { HelpVideo } from "@/components/HelpVideo";

export default function Certificate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/certificate/${id}`).then((r) => setCert(r.data)).catch((e) => setError(formatApiError(e.response?.data?.detail)));
  }, [id]);

  if (error)
    return (
      <div className="max-w-md mx-auto mt-20 text-center bg-white rounded-2xl border border-slate-200 p-10 shadow-sm">
        <AlertCircle className="h-12 w-12 text-orange-500 mx-auto mb-4" />
        <h1 className="font-display text-2xl font-bold text-slate-900">Certificado indisponível</h1>
        <p className="text-slate-500 mt-2">{error}</p>
        <Button className="mt-6" style={{ background: "#232D4F" }} onClick={() => navigate(`/app/curso/${id}`)}>Voltar ao curso</Button>
      </div>
    );

  if (!cert)
    return <div className="grid place-items-center h-[60vh]"><Loader2 className="h-6 w-6 animate-spin text-[#232D4F]" /></div>;

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6 print:hidden">
        <button onClick={() => navigate(`/app/curso/${id}`)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800">
          <ArrowLeft className="h-4 w-4" /> Voltar ao curso
        </button>
        <HelpVideo moment="certificado" label="Ver vídeo: certificado" title="Seu certificado: como baixar e validar" />
        <Button data-testid="btn-print-certificate" onClick={() => window.print()} className="text-white" style={{ background: "#1E9E2A" }}>
          <Printer className="h-4 w-4 mr-1.5" /> Imprimir / Salvar PDF
        </Button>
      </div>

      <CertificateView template={cert.template} fields={cert.fields} />

      <p className="text-center text-xs text-slate-400 mt-4 print:hidden">
        Valide a autenticidade deste certificado em <span className="font-mono text-slate-500">/validar</span> com o código <span className="font-mono text-slate-500">{cert.code}</span>.
      </p>
    </div>
  );
}
